import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';
import { CatalogoGeneralDTO } from 'src/app/core/models/vinculacion/vinculacion-Interfaces';
import { environment } from 'src/environments/environment';
const API_URL = environment.apiUrlVinculacion;

@Injectable()
export class CatalogoGeneralService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) {}

  getCatalogoGeneralService(): Observable<BodyListResponse<CatalogoGeneralDTO>> {
    return this.http.get<BodyListResponse<CatalogoGeneralDTO>>(API_URL + '/api/v1/catalogoGeneral/todos');
  }

   getCatalogoGeneralActivosService(): Observable<BodyListResponse<CatalogoGeneralDTO>> {
    return this.http.get<BodyListResponse<CatalogoGeneralDTO>>(API_URL + '/api/v1/catalogoGeneral');
  }

  guardarCatalogoGeneralService(catalogoGeneralDTO: CatalogoGeneralDTO): Observable<BodyResponse<CatalogoGeneralDTO>> {
    return this.http.post<any>(API_URL + '/api/v1/catalogoGeneral', catalogoGeneralDTO);
  }

  getCatalogoGeneralPorCodigoService(codigo: string): Observable<BodyResponse<CatalogoGeneralDTO>> {
    return this.http.get<BodyResponse<CatalogoGeneralDTO>>(API_URL + '/api/v1/catalogoGeneral/' + codigo);
  }
}
